<template>
    <div v-loading="loading" element-loading-text="请稍后..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="operate-div">
            <el-button size="mini" type="primary" @click="drawLine">绘制线路</el-button>
            <!-- <el-button size="mini" type="primary">导入线路</el-button> -->
        </div>
        <div>
            <!-- <TableModelPlusEx :max-height="'600px'" ref="table_flightRoam" :columns="columns" /> -->
            <YzTable :hasPage="false" :afterRequest="afterRequest" max-height="600px" :columnApi="columns"
                :listApi="listArray" :searchForm="searchForm" :autoLoad="true" ref="YzTable" />
        </div>
    </div>
</template>

<script>
import { createLine, deleteLine } from "@/api/line/index.js"
import DrawPolyline from "@/utils/cesiumBD/plot/DrawPolyline.js"
let DrawPolylineUti = undefined;
export default {
    data() {
        return {
            loading: false,
            listArray: "/line/queryLineList",
            searchForm: {},
            columns: "json/line.json",
        };
    },

    mounted() {
        this.$bus.$on("deleteflyRow", (id) => {
            this.deleteById(id);
        });
    },

    methods: {
        deleteById(id) {
            this.$confirm("是否删除该条数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteLine(id).then(() => {
                        this.$message({
                            showClose: true,
                            message: "删除成功！",
                            type: "success",
                            duration: 3 * 1000,
                        });
                        this.$refs["YzTable"].getList(this.searchForm, true);
                        var uuid = id + '_xl_';
                        var entity = viewer.entities.getById(uuid);
                        if (entity) {
                            viewer.entities.remove(entity);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        type: "info",
                        message: "本次操作已取消！",
                        duration: 3 * 1000,
                    });
                });
        },
        afterRequest(res) {
            return {
                result: {
                    items: res.result,
                    total: 0
                }
            }
        },
        getPlot(plot) {
            var keyPos = plot.polyline.positions.getValue();
            if (keyPos.length < 1) {
                return;
            }
            this.loading = true;
            createLine({
                line: JSON.stringify(keyPos)
            }).then(res => {
                var id = res.result.id;
                var uuid = id + '_xl_';
                viewer.entities.remove(plot);
                this.createLineEntity(keyPos, uuid);
                this.$refs["YzTable"].getList(this.searchForm, true);
                this.$message({
                    message: "线路创建成功",
                    type: "success",
                });
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                console.error(e);
            });
            // var row = {
            //     linePos: keyPos,
            //     id: id
            // };

            // var has = this.$refs["table_flightRoam"].findById(id);
            // if (has >= 0) {

            //     this.$refs["table_flightRoam"].updateList(has,row);
            //     return;
            // }

            // this.$refs["table_flightRoam"].addFirst(row);
        },
        createLineEntity(positions, id) {
            var line = viewer.entities.add({
                show: true,
                id: id,
                polyline: {
                    positions: positions,
                    show: true,
                    material: Cesium.Color.RED,
                    width: 3,
                    clampToGround: true,
                    disableDepthTestDistance: Number.MAX_VALUE,
                }
            });
            return line;
        },
        updatePlot() {
            var keyPos = plot.attrPlot['edit_positions'];
            if (keyPos.length < 1) {
                return;
            }

            var row = {
                linePos: keyPos
            };
        },
        drawLine() {
            if (!DrawPolylineUti) {
                DrawPolylineUti = new DrawPolyline({
                    canEdit: false,
                    callback: this.getPlot,
                });
            }

            DrawPolylineUti.reset();
            DrawPolylineUti.start();
        }
    },

    beforeDestroy() {
        this.$bus.$off("deleteflyRow");
        DrawPolylineUti && DrawPolylineUti.clear();
        DrawPolylineUti = undefined;
        viewer.clock.multiplier = 1;
    }
};
</script>

<style lang="scss" scoped>
.operate-div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}
</style>